// AUTO-GENERATED by scripts/gen-icons.mjs — do not edit by hand.
import Svg from '../svg/arrow-down.svg?react';
import { Icon } from '../Icon';
import { IconProps } from '../types';

export const ArrowDownIcon = (props: IconProps) => <Icon svg={Svg} {...props} />;
